import React, { useCallback, useEffect, useMemo, useState } from 'react';
import {
 Switch,
 Route,
 Redirect,
 useLocation,
 useHistory,
} from 'react-router-dom';
import { useQueryClient, useMutation } from 'react-query';
import { Alert, Button, Select } from 'antd';
import { SignoutIcon, ManhattanImage, CompanyIcon } from '../../_assests';
// import { Uid } from '../..';
import srv from '../../../services';
import {
 Spin,
 Errors,
 Wrapper,
 Logo,
 MenuStyled,
 MenuItem,
 Logout,
 Main,
 Content,
 HeaderWrapper,
 Header,
 Title,
 Widgets,
 Company,
 Avatar,
 Manhattan,
 Footer,
} from './Layout.styled';
import ChatwootWidget from '../../_common/ChatwootWidget';
import { Badge } from 'antd';
import { BellOutlined } from '@ant-design/icons';
import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import * as signalR from '@microsoft/signalr';
import { RootState } from '../../../store/store';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { AppDispatch } from '../../../store/store';
import { getContragent } from '../../../store/reducers/getContragentSlice';
import { getContragentAllData } from '../../../store/reducers/getContragentAllDataSlice';

interface Props {
 isLoading?: boolean;
 error?: unknown;
 navigation: {
  url: string;
  name?: string;
  icon?: any;
  component: React.FunctionComponent;
  featured?: boolean;
 }[];
}

export default function MainLayout({
 isLoading = false,
 error,
 navigation,
}: Props) {
 const { userNav, activeNavItem, contragent, contragentList } =
  useNav(navigation);
 const { user, onLogout } = useUser();
 const queryClient = useQueryClient();

 const history = useHistory();

 const configData = useSelector(
  (state: RootState) => state.config,
  shallowEqual,
 );

 //  const [connection, setConnection] = useState(null);
 //  const [messages, setMessages] = useState([]);

 //  useEffect(() => {
 //   const newConnection = new HubConnectionBuilder()
 //    //.withUrl('https://ulk.vostok-electra.ru/hubs/ais-status')
 //    .withUrl('https://ulk.vostok-electra.ru/hubs/ais-status', {
 //     withCredentials: false,
 //    })
 //    .withAutomaticReconnect()
 //    .configureLogging(LogLevel.Information)
 //    .build();

 //   setConnection(newConnection);
 //  }, []);

 //  useEffect(() => {
 //   if (connection) {
 //    connection
 //     .start()
 //     .then(() => {
 //      console.log('Connected to SignalR Hub');

 //      connection.on('ReceiveMessage', (user, message) => {
 //       setMessages((prev) => [...prev, { user, message }]);
 //      });
 //     })
 //     .catch((err) => {
 //      console.error('Connection failed: ', err);
 //     });

 //    // 4. Cleanup on component unmount
 //    return () => {
 //     connection.off('ReceiveMessage');
 //     connection.stop();
 //    };
 //   }
 //  }, [connection]);

 const { mutate: updateContragent } = useMutation(srv.setSelectContragent, {
  onSuccess: () => {
   queryClient.refetchQueries('contragent');
   queryClient.refetchQueries('appeals');
   queryClient.refetchQueries('contracts');
   queryClient.clear();
  },
 });

 const notificationNotReadCount = useQueryClient().getQueryData<any>(
  'notificationNotReadCount',
 );

 const gotoNotification = () => {
  history.push('/contracts/notifications');
 };

 const onUpdateContragent = useCallback(
  (defaultUid: string) => {
   updateContragent(defaultUid);
  },
  [updateContragent],
 );

 const { pathname } = useLocation();

 if (isLoading) return <Spin size="large" />;

 if (error)
  return (
   <Errors>
    <Alert
     type="error"
     showIcon
     message="Произошла ошибка при загрузке данных"
     description={error}
    />

    <Button onClick={() => window.location.reload()}>Повторить попытку</Button>
   </Errors>
  );

 return (
  <Wrapper>
   <MenuStyled>
    <a href={configData.siteUrl}>
     <Logo
      src={configData.logoFileName}
      alt={configData.companyShortName}
      style={{
       marginBottom: '80px',
       height: `${configData.logoMenuHeight}px`,
      }}
     />
    </a>
    {userNav.map((item) => {
     if (!item.name) return null;
     if (item.url === '/payment' && configData.showPayment === '0') {
      return null;
     } else {
      if (item.url === '/feedback' && configData.showSupport === '0') {
       return null;
      } else {
       if (item.url === '/broadcast' && configData.showDevice === '0') {
        return null;
       } else {
        if (item.url === '/map' && configData.showMap === '0') {
         return null;
        } else {
         if (item.url === '/settings' && configData.showSettings === '0') {
          return null;
         } else {
          if (item.url === '/contracts' && configData.showMain === '0') {
           return null;
          } else {
           return (
            <MenuItem
             key={item.url}
             to={item.url}
             title={item.name}
             featured={item.featured}
            >
             {item.icon}
            </MenuItem>
           );
          }
         }
        }
       }
      }
     }
    })}

    <Logout to="/" activeClassName="" title="Выход" onClick={onLogout}>
     <div
      style={{
       display: 'flex',
       flexDirection: 'column',
       justifyContent: 'center',
       justifyItems: 'center',
       alignContent: 'center',
       alignItems: 'center',
       textAlign: 'center',
       fontSize: '10px',
      }}
     >
      <div>
       <SignoutIcon />
      </div>
      <div>Выход</div>
     </div>
    </Logout>
   </MenuStyled>

   <Main>
    <HeaderWrapper>
     <Header>
      <Title>
       <Logo src={configData.logoFileName} alt={configData.companyShortName} />
       <h1>{activeNavItem?.name}</h1>
      </Title>

      {!!user?.uid && (
       <Widgets>
        <Company>
         <Avatar>
          {/*<CompanyIcon />*/}
          Выбор контрагента:
         </Avatar>
         {contragentList?.length > 1 ? (
          <Select
           value={contragent?.companyShortName}
           style={{
            width: '1000px',
            marginTop: '5px',
           }}
           bordered={false}
           onChange={(value) => {
            onUpdateContragent(value);
           }}
          >
           {contragentList.map((company) => {
            return (
             <Select.Option
              value={company.uid}
              key={company.id}
              title={company.companyName}
             >
              {company.companyShortName}
             </Select.Option>
            );
           })}
          </Select>
         ) : (
          <Company>
           <b>{contragent.companyShortName || contragent.companyName}</b>
          </Company>
         )}
        </Company>
       </Widgets>
      )}

      <div
       onClick={gotoNotification}
       style={{ cursor: 'pointer', marginTop: '10px' }}
      >
       <Badge count={notificationNotReadCount} offset={[5, 0]}>
        <BellOutlined style={{ fontSize: '24px' }} />
       </Badge>
      </div>
     </Header>
    </HeaderWrapper>

    <Content key={pathname}>
     <Switch>
      {userNav.map((item) => (
       <Route key={item.url} path={item.url} component={item.component} />
      ))}

      {!!userNav[0] && (
       <Route render={() => <Redirect to={userNav[0].url} />} />
      )}
     </Switch>

     {!!user?.uid && (
      <Manhattan>
       <ManhattanImage />
      </Manhattan>
     )}
     <Footer />
    </Content>
   </Main>

   {configData.showChatWoot === '1' ? <ChatwootWidget /> : ''}
  </Wrapper>
 );
}

function useNav(navigation: Props['navigation']) {
 const { pathname } = useLocation();
 const contragent =
  useQueryClient().getQueryData<Models.Contragent>('contragent');

 const dispatch = useDispatch<AppDispatch>();

 useEffect(() => {
  if (contragent) {
   dispatch(getContragent(contragent.id));
   dispatch(getContragentAllData(contragent));
  }
 }, [contragent]);

 const contragentList =
  useQueryClient().getQueryData<Models.ContragentList[]>('contragentList');

 const user = useQueryClient().getQueryData<Models.User>('user');

 const userNav = useMemo(() => {
  // if (contragent?.contragentType === "Юридическое лицо") {
  //   navigation.splice(1, 1);
  //   return navigation;
  // } else {
  return navigation.map((item) => {
   //  if (!user?.uid)
   //   return {
   //    ...item,
   //    component: Uid,
   //   };
   return item;
  });
  // }
 }, [user, navigation, contragent?.contragentType]);

 const activeNavItem = useMemo(() => {
  return navigation.find((item) => pathname.includes(item.url));
 }, [navigation, pathname]);

 return { userNav, activeNavItem, contragent, contragentList };
}

function useUser() {
 const queryClient = useQueryClient();

 const user = queryClient.getQueryData<Models.User>('user');

 const onLogout = useCallback(() => {
  localStorage.removeItem('token');
  queryClient.resetQueries('user');
  queryClient.clear();
 }, [queryClient]);

 return { user, onLogout };
}
